import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const SERVER_YII_URL_TOKEN = new InjectionToken<Observable<string>>('serverYiiURL');
